import React, { Component } from "react";
import { connect } from "react-redux";
import { setJumbotronTitle } from "../../actions/common";
import WithAjax from "../common/helpers/WithAjax";
import ProfileList from "./helpers/ProfileList";

class IncompleteProfiles extends Component {
  constructor() {
    super();

    this.state = {
      items: [],
    };

    this.columns = ["AvatarImage", "SkillVendorFullName", "ProfileTypeLabel", "StatusModifiedDate"];

    this.columnNames = ["", "Full name", "Profile type", "Status modified date"];

    this.tableSortDefinition = [
      "SkillVendorFullName",
      "ProfileTypeLabel",
      {
        column: "StatusModifiedDate",
        sortFunction: function(a, b) {
          return a.props.statusmodifieddate.localeCompare(b.props.statusmodifieddate);
        },
      },
    ];
  }

  componentDidMount() {
    this.props.setJumbotronTitle("Pending incomplete");

    let url = "profiles/incomplete";
    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return (data[index].NavigationParam = data[index].SkillVendorId);
      });

      this.setState({
        items: data,
      });
    });
  }

  render() {
    return (
      <ProfileList
        urlExport="profiles/export/incomplete"
        columns={this.columns}
        columnNames={this.columnNames}
        items={this.state.items}
        label={"Incomplete"}
        tableSortDefinition={this.tableSortDefinition}
        filterable={[
          {
            column: "ProfileTypeLabel",
            filters: "auto",
          },
        ]}
        searchable={["SkillVendorFullName"]}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({
  setJumbotronTitle(title) {
    dispatch(setJumbotronTitle(title));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAjax(IncompleteProfiles));
